import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Spin, Card, Icon, Button, Input } from 'antd';
import base from '../../tool/base';
import util from '../../util';

const {
  getAccessToken
} = util;

const store = [
  'workflowStore',
  'homeStore',
]

@inject(...store)
@observer
export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  getNumUnits = num => num < 1000 ? num : `${(num / 1000).toFixed(1)}k`;

  collection = appId => {
    const { workflowStore: { setStars } } = this.props;
    setStars({appId}).then(data => data.msg !== '未登录' && this.getFolderIdInfo());
  }

  download = (id, folderId) => {
    const url = `${window.server}/v5/ecode/download?id=${id}&access_token=${getAccessToken()}`;
    const { workflowStore: { params, getCaseList}, appId } = this.props;
    base.callApi('/v5/ecode/downloadCount', 'POST', {appId: folderId}, 'json', 'text').then((data) => {
      if (data.status) {
        window.open(url);
        this.getFolderIdInfo();
      } else {
        console.error("后端接口异常，请联系管理员！");
      }
    });
  }

  getFolderIdInfo = () => {
    const { workflowStore: { getCaseList, getDetail }, detail, params } = this.props;
    detail ? 
      getDetail({
        ...params,
      })
      :getCaseList(params, false);
  }

  render() {
    const { item, className, children, workflowStore: {starsLoading}, homeStore: { addCollect, addCollectLoading } } = this.props;
    return (
      <div className={`workflow-info ${className}`}>
        {children}
        <div className="workflow-info-box">
          <span className="workflow-info-box-item">分享人：<span className="workflow-info-box-light">{item.creatorName}</span></span>
          <span className="workflow-info-box-item">分享来源：<span>{item.weaver ? '泛微软件' : '客户方'}</span></span>
        </div>
        <div className="workflow-info-box">
          <ul className="workflow-info-box-list">
            <li><Icon type="eye" />{this.getNumUnits(item.visits)}</li>
            <li className="pointer" onClick={() => this.download(item.id, item.folderId)}><Icon type="download" />{this.getNumUnits(item.downloadCounts)}</li>
            <li className="pointer" onClick={() => !starsLoading && this.collection(item.folderId)}>
              <Icon type="like" className={item.thumbsupStatus === 'y' ? "heart-active" : "" } theme={item.thumbsupStatus === 'y' ? "filled" : "" }/>
              {this.getNumUnits(item.thumbsup)}
            </li>
            <li className="pointer" onClick={() => addCollectLoading || addCollect({appId: item.folderId}).then(data => data.status && this.getFolderIdInfo())}>
              <Icon type="star" className={item.starStatus === 'y' ? "star-active" : "" } theme={item.starStatus === 'y' ? "filled" : "" }/>
              {this.getNumUnits(item.stars)}
            </li>
          </ul>
            <span className="workflow-info-box-date">{item.modifyDate}</span>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/workflow/ItemInfo.js